import React, { memo, useMemo } from 'react'
import { graphql } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'
import BackgroundImage from 'gatsby-background-image'
import { convertToBgImage } from 'gbimage-bridge'

import Button from '../components/Button'
import { useMatchMedia } from '../hooks/useMatchMedia'

const SustainabilitySection = ({ slice }) => {
  const { primary, items } = slice
  const bgImage = convertToBgImage(primary?.background_image.gatsbyImageData)
  const { isMatching, calculated } = useMatchMedia('(max-width:510px)', true)

  const elements = useMemo(
    () => (
      <div className="container">
        <div className="sustainability-description">
          <PrismicRichText field={primary?.title?.richText} />
          <p className="p-18">{primary?.description?.text}</p>
          <Button data={primary} />
        </div>
      </div>
    ),
    [primary],
  )

  return (
    <section className={`section sustainability-section`}>
      {!isMatching && calculated ? (
        <BackgroundImage Tag="div" {...bgImage}>
          {elements}
        </BackgroundImage>
      ) : (
        elements
      )}
    </section>
  )
}

export default memo(SustainabilitySection)

export const query = graphql`
  fragment HomepageDataBodySustainability on PrismicHomepageDataBodySustainability {
    id
    primary {
      background_image {
        gatsbyImageData
        alt
      }
      button_link {
        url
        target
      }
      button_title {
        text
      }
      button_theme
      title {
        richText
      }
      description {
        text
      }
    }
  }
  fragment PageDataBodySustainability on PrismicPageDataBodySustainability {
    id
    primary {
      background_image {
        gatsbyImageData
        alt
      }
      button_link {
        url
        target
      }
      button_title {
        text
      }
      button_theme
      title {
        richText
      }
      description {
        text
      }
    }
  }
  fragment SolutionsDataBodySustainability on PrismicSolutionsDataBodySustainability {
    id
    primary {
      background_image {
        gatsbyImageData
        alt
      }
      button_link {
        url
        target
      }
      button_title {
        text
      }
      button_theme
      title {
        richText
      }
      description {
        text
      }
    }
  }
`
